module.exports = __webpack_public_path__ + "img/bcg-logo-blue.abbd1c44.svg";